export const FUNNELS = [
  'baseline-v2',
  'baseline-promo',
  'round-only',
  'baseline-us',
  'google',
  'tiktok',
  'retargeting',
  'email',
  '01_feel18',
  '02_transform12w',
  '03_transform28d',
  '04_rewind28d',
  '05_rewind12w',
  '07_reflectage',
  '08_control',
  '09_trainpelvic',
  '10_top1decline',
  '11',
  '12',
  '13',
  '14',
  '15',
  '21',
  '22',
  '23',
  '24',
  '25',
  '31',
  '32',
  '33',
  '34',
  '35',
] as const;
export type FunnelId = 'baseline' | typeof FUNNELS[number];

export { LOCALE_CODES, LOCALE_FILES as LOCALE_FILENAMES } from '../layers/core/base/shared/locales';
export type { LocaleCode } from '../layers/core/base/shared/locales';
